import { Box } from '@material-ui/core'
import React from 'react'
import QuestionAttribute from "./QuestionAttribute"

type QuestionItemType = {
    item: any,
    unitId: any
}

const renderAttributes = (item: any, unitId: any) => {
    return item.values.map((attribute: any, index: any) => {
        return (
            <QuestionAttribute attribute={attribute} itemKey={item.key} unitId={unitId} key={index} />
        )
    })
}

export default function QuestionItem({ item, unitId }: QuestionItemType) {
    return (
        <Box>
            {renderAttributes(item, unitId)}
        </Box>
    )
}
